export class DenyReason {
  name: string;
  id: number;
}
